import Bowser from 'bowser'
export default Bowser.getParser(window.navigator.userAgent).is('mobile')
